import type { BillingInterval } from '@scio3/shared-types';
import { BillingCycleToggle } from '../../components/BillingCycleToggle';

type Props = {
  billingInterval: BillingInterval;
  onBillingIntervalChange: (value: BillingInterval) => void;
  monthlyPrice: number;
  yearlyPrice: number;
  screenCount: number;
  currency?: string;
};

export function WizardStepPaymentTerm({
  billingInterval,
  onBillingIntervalChange,
  monthlyPrice,
  yearlyPrice,
  screenCount,
  currency,
}: Props) {
  return (
    <div className="py-4">
      <BillingCycleToggle
        value={billingInterval}
        onChange={onBillingIntervalChange}
        monthlyPricePerScreen={monthlyPrice}
        yearlyPricePerScreen={yearlyPrice}
        screenCount={screenCount}
        currency={currency}
      />
    </div>
  );
}
